<template>
  <section class="section">
  <div class="well d-flex justify-content-center">
    <h2>404 NOT FOUND</h2>
  </div>
  </section>
</template>
<script>
export default {

};
</script>
<style>
</style>
